/* hb-scripts.js — behaviour for the hb-* homepage sections (no dependencies) */
(function () {
  'use strict';
  // Several sections include this file; only the first copy may run, or every handler gets bound once per copy.
  if (window.__hbScriptsLoaded) return;
  window.__hbScriptsLoaded = true;
  document.documentElement.classList.add('hb-js');
  /* mark an element as wired; returns false if it already was (keeps every binder idempotent) */
  function claim(el, key) {
    // own namespace: 'hb' + 'ModalOpen' would be the trigger's real data-hb-modal-open attribute
    var k = 'hbBound' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll-in animations ---------- */
  function initAnimations(root) {
    var items = (root || document).querySelectorAll('.hb-anim:not(.hb-anim--bound)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) { el.classList.add('hb-anim--in', 'hb-anim--bound'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hb-anim--in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { el.classList.add('hb-anim--bound'); io.observe(el); });
  }

  /* ---------- top bar rotation ---------- */
  function initTopbar(bar) {
    var items = bar.querySelectorAll('.hb-topbar__item');
    if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
    var i = 0, delay = (parseInt(bar.dataset.speed, 10) || 5) * 1000, paused = reduceMotion;
    items.forEach(function (it, n) { it.setAttribute('aria-hidden', n === 0 ? 'false' : 'true'); });
    items[0].classList.add('is-active');
    ['mouseenter', 'focusin'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = reduceMotion; }); });
    setInterval(function () {
      if (paused) return;
      items[i].classList.remove('is-active'); items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active'); items[i].setAttribute('aria-hidden', 'false');
    }, delay);
  }

  /* ---------- header: sticky, mega menu, drawer ---------- */
  /* Horizon scrolls an inner .page-wrapper rather than the window; find whichever actually scrolls */
  function scrollContainer() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && getComputedStyle(pw).overflowY !== 'visible' && pw.scrollHeight > pw.clientHeight + 1) return pw;
    return window;
  }
  function scrollTopOf(c) { return c === window ? window.scrollY : c.scrollTop; }
  /* whichever container is scrolling right now; Horizon switches between window and .page-wrapper by breakpoint */
  function currentScrollTop() {
    var pw = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, pw ? pw.scrollTop : 0);
  }
  function lockScroll(on) {
    // stay locked while another overlay (drawer or panel) is still open
    if (!on && document.querySelector('.hb-modal.is-open, .hb-header.is-drawer-open')) return;
    var c = scrollContainer();
    (c === window ? document.body : c).style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function initHeader(header) {
    // keep --hb-topbar-h equal to the real announcement bar height so the sticky offset is exact
    var group = document.getElementById('header-group');
    var topbar = group && group.querySelector('.hb-topbar');
    // measured height goes to its own variable: feeding it back into the bar's min-height made the bar grow and never shrink
    function measureTopbar() { if (group) group.style.setProperty('--hb-topbar-offset', (topbar ? topbar.offsetHeight : 0) + 'px'); }
    measureTopbar();
    window.addEventListener('resize', measureTopbar);
    var container = header.querySelector('.hb-header__container');
    // the drawer starts where the header really ends (below the announcement bar at the top of the page)
    function setDrawerTop() { if (container) header.style.setProperty('--hb-drawer-top', Math.max(0, Math.round(container.getBoundingClientRect().bottom)) + 'px'); }
    var onScroll = function () {
      header.classList.toggle('is-sticky', currentScrollTop() > 0);
      if (header.classList.contains('is-drawer-open')) setDrawerTop();
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var pwEl = document.querySelector('.page-wrapper');
    if (pwEl) pwEl.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    var megaItems = header.querySelectorAll('[data-hb-mega-trigger]');
    var panels = header.querySelectorAll('.hb-mega__panel');
    var mega = header.querySelector('.hb-mega');
    var closeTimer, switchTimer;
    function triggerLink(li) { return li.querySelector('.hb-nav__link'); }
    function openMega(key) {
      clearTimeout(closeTimer); clearTimeout(switchTimer);
      var found = false;
      panels.forEach(function (p) {
        var on = p.dataset.hbMegaPanel === key;
        p.classList.toggle('is-active', on);
        if (on) found = true;
      });
      megaItems.forEach(function (li) {
        var on = li.dataset.hbMegaTrigger === key;
        li.classList.toggle('is-open', on);
        var a = triggerLink(li); if (a) a.setAttribute('aria-expanded', String(on));
      });
      header.classList.toggle('is-mega-open', found);
      if (mega) mega.setAttribute('aria-hidden', String(!found));
    }
    function closeMega() {
      clearTimeout(switchTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        // the active panel stays in place so it can fade out with the overlay instead of vanishing
        header.classList.remove('is-mega-open');
        megaItems.forEach(function (li) {
          li.classList.remove('is-open');
          var a = triggerLink(li); if (a) a.setAttribute('aria-expanded', 'false');
        });
        if (mega) mega.setAttribute('aria-hidden', 'true');
      }, 150);
    }
    megaItems.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        clearTimeout(switchTimer);
        clearTimeout(closeTimer);
        // hover intent: with a panel already open, switch only once the pointer rests on another item,
        // so a diagonal move toward the panel doesn't flip to the neighbouring item's panel
        if (!header.classList.contains('is-mega-open')) openMega(li.dataset.hbMegaTrigger);
        else switchTimer = setTimeout(function () { openMega(li.dataset.hbMegaTrigger); }, 120);
      });
      li.addEventListener('mouseleave', function () { clearTimeout(switchTimer); });
      li.addEventListener('focusin', function () { openMega(li.dataset.hbMegaTrigger); });
    });
    header.querySelectorAll('.hb-nav__item:not([data-hb-mega-trigger])').forEach(function (li) {
      li.addEventListener('mouseenter', closeMega);
      li.addEventListener('focusin', closeMega);
    });
    header.addEventListener('focusout', function (e) { if (!header.contains(e.relatedTarget)) closeMega(); });
    // Tab from an open item goes into its panel; Tab off the panel's last link continues to the next item
    megaItems.forEach(function (li) {
      var a = triggerLink(li);
      if (!a) return;
      a.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || e.shiftKey || !li.classList.contains('is-open')) return;
        var first = header.querySelector('[data-hb-mega-panel="' + li.dataset.hbMegaTrigger + '"] a');
        if (first) { e.preventDefault(); first.focus(); }
      });
    });
    panels.forEach(function (p) {
      var links = p.querySelectorAll('a');
      var li = header.querySelector('[data-hb-mega-trigger="' + p.dataset.hbMegaPanel + '"]');
      if (!links.length || !li) return;
      links[links.length - 1].addEventListener('keydown', function (e) {
        var nextLi = li.nextElementSibling;
        var next = nextLi && nextLi.querySelector('a');
        if (e.key === 'Tab' && !e.shiftKey && next) { e.preventDefault(); next.focus(); }
      });
      links[0].addEventListener('keydown', function (e) {
        if (e.key === 'Tab' && e.shiftKey) { e.preventDefault(); var a = triggerLink(li); if (a) a.focus(); }
      });
    });
    if (mega) {
      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(switchTimer); });
      header.addEventListener('mouseleave', closeMega);
      var overlay = mega.querySelector('.hb-mega__overlay');
      if (overlay) {
        overlay.addEventListener('click', closeMega);
        // the overlay belongs to the header, so the header never sees the mouse leave. Close when the pointer
        // really moves off the bar or panel onto it (not when it appears under a resting pointer).
        overlay.addEventListener('mouseenter', function (e) { if (e.relatedTarget && header.contains(e.relatedTarget)) closeMega(); });
      }
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (header.classList.contains('is-mega-open')) { closeMega(); var openLi = header.querySelector('.hb-nav__item.is-open .hb-nav__link'); if (openLi) openLi.focus(); }
      if (header.classList.contains('is-drawer-open')) { closeDrawer(); if (trigger) trigger.focus(); }
    });

    var trigger = header.querySelector('[data-hb-drawer-trigger]');
    function closeDrawer() {
      header.classList.remove('is-drawer-open');
      if (trigger) { trigger.classList.remove('is-active'); trigger.setAttribute('aria-expanded', 'false'); }
      lockScroll(false);
    }
    if (trigger) {
      trigger.addEventListener('click', function () {
        var open = !header.classList.contains('is-drawer-open');
        if (open) setDrawerTop();
        header.classList.toggle('is-drawer-open', open);
        trigger.classList.toggle('is-active', open);
        trigger.setAttribute('aria-expanded', String(open));
        lockScroll(open);
      });
    }
    header.querySelectorAll('.hb-drawer__row[data-hb-sub]').forEach(function (row) {
      if (!claim(row, 'Sub')) return;
      row.addEventListener('click', function () {
        var item = row.parentElement;
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        row.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- modals ---------- */
  var modalEscBound = false;
  function initModals() {
    document.querySelectorAll('[data-hb-modal-open]').forEach(function (btn) {
      if (!claim(btn, 'ModalOpen')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var m = document.getElementById(btn.dataset.hbModalOpen);
        if (!m) return;
        m.classList.add('is-open');
        m.hbOpener = btn;
        lockScroll(true);
        var f = m.querySelector('input:not([type=hidden])') || m.querySelector('button');
        if (f) f.focus();
      });
    });
    document.querySelectorAll('.hb-modal').forEach(function (m) {
      m.querySelectorAll('[data-hb-modal-close]').forEach(function (c) {
        if (!claim(c, 'ModalClose')) return;
        c.addEventListener('click', function () { m.classList.remove('is-open'); lockScroll(false); if (m.hbOpener) m.hbOpener.focus(); });
      });
    });
    if (modalEscBound) return;
    modalEscBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelectorAll('.hb-modal.is-open');
      if (!open.length) return;
      open.forEach(function (m) { m.classList.remove('is-open'); });
      lockScroll(false);
      var last = open[open.length - 1];
      if (last && last.hbOpener) last.hbOpener.focus();
    });
  }

  /* ---------- hero carousel ---------- */
  function initHero(hero) {
    var slides = hero.querySelectorAll('.hb-hero__slide');
    var bullets = hero.querySelectorAll('.hb-hero__bullet');
    var toggle = hero.querySelector('.hb-hero__toggle');
    var autoplay = hero.dataset.autoplay === 'true' && slides.length > 1 && !reduceMotion;
    var interval = (parseInt(hero.dataset.interval, 10) || 6) * 1000;
    var current = 0, timer;

    function videosIn(slide) { return slide.querySelectorAll('video'); }
    function pauseAll() { videosIn(hero).forEach(function (v) { v.pause(); }); }
    function playVisible(slide) {
      videosIn(slide).forEach(function (v) {
        // only the copy that is actually displayed at this width plays
        if (hero.classList.contains('is-paused') || !v.getClientRects().length) { v.pause(); return; }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    }
    function go(n) {
      slides[current].classList.remove('is-active');
      videosIn(slides[current]).forEach(function (v) { v.pause(); });
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      bullets.forEach(function (b, i) { b.classList.toggle('is-active', i === current); b.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      playVisible(slides[current]);
    }
    function start() { if (!autoplay) return; stop(); timer = setInterval(function () { go(current + 1); }, interval); }
    function stop() { clearInterval(timer); }

    bullets.forEach(function (b, i) { b.addEventListener('click', function () { go(i); start(); }); });
    if (toggle) {
      toggle.addEventListener('click', function () {
        var paused = hero.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        if (paused) { stop(); videosIn(hero).forEach(function (v) { v.pause(); }); }
        else { playVisible(slides[current]); start(); }
      });
    }
    // swipe support
    var startX = null;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (startX === null || slides.length < 2) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); start(); }
      startX = null;
    });
    if (reduceMotion) { videosIn(hero).forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); }); hero.classList.add('is-paused'); if (toggle) toggle.setAttribute('aria-pressed', 'true'); }
    else { pauseAll(); playVisible(slides[current]); }
    start();
    var mq = window.matchMedia('(min-width: 768px)');
    var onBreakpoint = function () { pauseAll(); playVisible(slides[current]); };
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint); else if (mq.addListener) mq.addListener(onBreakpoint);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        // off-screen heroes stop decoding video
        entries.forEach(function (en) { if (en.isIntersecting) { start(); playVisible(slides[current]); } else { stop(); pauseAll(); } });
      }).observe(hero);
    }
  }

  /* ---------- shared: wishlist hearts (local only — swap for your wishlist app) ---------- */
  var WISH_KEY = 'hb-wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function bindWishlist(btn) {
    if (!claim(btn, 'Wish')) return;
    var id = btn.dataset.handle;
    if (readWishlist().indexOf(id) > -1) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
    btn.addEventListener('click', function () {
      var on = btn.classList.toggle('is-active');
      btn.setAttribute('aria-pressed', String(on));
      // re-read so two hearts for the same product on one page don't overwrite each other's list
      var saved = readWishlist().filter(function (h) { return h !== id; });
      if (on) saved.push(id);
      try { localStorage.setItem(WISH_KEY, JSON.stringify(saved)); } catch (e) {}
    });
  }

  /* ---------- shared: add to cart in the background, update the bag count, announce it ---------- */
  function cartRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  // the theme's cart drawer (layout/theme.liquid renders it when the cart type is "drawer")
  var DRAWER_SECTION = 'cart-drawer-section';
  function refreshCartDrawer(html) {
    var oldInner = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (!html || !oldInner) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newInner = doc.querySelector('.cart-drawer__inner');
    if (newInner) oldInner.replaceWith(document.importNode(newInner, true));
  }
  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    return false;
  }
  // header bag opens the drawer (the /cart link stays as the no-JS fallback);
  // on wide screens the drawer overlays the page, and a click on the dimmed backdrop (body::after) closes it
  document.addEventListener('click', function (e) {
    var bag = e.target.closest && e.target.closest('[data-hb-cart-open]');
    if (bag) { if (openCartDrawer()) e.preventDefault(); return; }
    var drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.hasAttribute('open') && e.target === document.body && typeof drawer.close === 'function') drawer.close();
  });
  function addToCart(body, withDrawer) {
    if (withDrawer && document.getElementById('cart-drawer')) {
      body.append('sections', DRAWER_SECTION);
      body.append('sections_url', window.location.pathname);
    }
    return fetch(cartRoot() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) { var err = new Error(json.description || json.message || 'Could not add to bag'); err.handled = r.status === 422; throw err; }
          return json;
        });
      })
      .then(function (item) {
        if (withDrawer && item && item.sections) refreshCartDrawer(item.sections[DRAWER_SECTION]);
        var status = document.querySelector('[data-hb-status]');
        if (status) status.textContent = (item && item.product_title ? item.product_title : 'Item') + ' added to your bag';
        return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('.hb-header__count').forEach(function (c) { c.textContent = cart.item_count; c.dataset.count = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'hb-add' } }));
        return cart;
      });
  }
  // a plain form post if anything fails
  function bindQuickAdd(form) {
    if (!claim(form, 'QuickAdd')) return;
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn && btn.querySelector('span');
      btn.setAttribute('aria-busy', 'true');
      var withDrawer = form.hasAttribute('data-hb-open-cart');
      addToCart(new FormData(form), withDrawer)
        .then(function () {
          btn.classList.add('is-added');
          if (withDrawer) openCartDrawer();
          if (label && btn.dataset.addedLabel) {
            var was = label.textContent;
            label.textContent = btn.dataset.addedLabel;
            setTimeout(function () { label.textContent = was; }, 2500);
          }
        })
        .catch(function () { form.submit(); })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- wishlist page: cards for the hearted handles, rendered by the hb-wishlist-card section ---------- */
  function initWishlistPage(root) {
    var grid = root.querySelector('[data-hb-wishlist-grid]');
    var empty = root.querySelector('[data-hb-wishlist-empty]');
    var status = root.querySelector('[data-hb-wishlist-status]');
    var sectionId = root.dataset.cardSection || 'hb-wishlist-card';
    if (!grid) return;
    function refresh() {
      var n = grid.children.length;
      if (empty) empty.hidden = n > 0;
      if (status) status.textContent = n ? n + (n === 1 ? ' piece saved' : ' pieces saved') : '';
    }
    var handles = readWishlist();
    if (!handles.length) { refresh(); return; }
    root.setAttribute('aria-busy', 'true');
    Promise.all(handles.map(function (h) {
      return fetch(cartRoot() + 'products/' + encodeURIComponent(h) + '?section_id=' + sectionId)
        .then(function (r) { return r.ok ? r.text().then(function (t) { return { html: t } }) : { gone: r.status === 404 }; })
        .catch(function () { return {}; });
    })).then(function (results) {
      var gone = [];
      results.forEach(function (res, i) {
        if (res.gone) { gone.push(handles[i]); return; }
        if (!res.html) return;
        var card = new DOMParser().parseFromString(res.html, 'text/html').querySelector('.hb-card');
        // a product that no longer exists renders the section empty (Shopify answers 200, not 404)
        if (!card) { gone.push(handles[i]); return; }
        var li = document.createElement('li');
        li.className = 'hb-coll__item';
        li.dataset.handle = handles[i];
        li.appendChild(document.importNode(card, true));
        grid.appendChild(li);
      });
      // forget products that were deleted from the store
      if (gone.length) {
        var keep = readWishlist().filter(function (h) { return gone.indexOf(h) < 0; });
        try { localStorage.setItem(WISH_KEY, JSON.stringify(keep)); } catch (e) {}
      }
      initProductCarousel(root);
      root.removeAttribute('aria-busy');
      refresh();
    });
    // un-hearting a card here removes it from the page
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.hb-card__wish');
      if (!btn) return;
      setTimeout(function () {
        if (btn.classList.contains('is-active')) return;
        var li = btn.closest('li');
        if (li) li.remove();
        refresh();
      }, 0);
    });
  }

  /* ---------- product carousel: tabs + arrows ---------- */
  function initProductCarousel(section) {
    var tabs = section.querySelectorAll('.hb-pc__tab');
    var contents = section.querySelectorAll('.hb-pc__content');
    function activate(i, focus) {
      tabs.forEach(function (t, j) { var on = i === j; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      contents.forEach(function (c, j) { c.classList.toggle('is-active', i === j); c.setAttribute('aria-hidden', String(i !== j)); });
      if (focus) tabs[i].focus();
    }
    // ARIA tabs pattern: click, or arrow keys / Home / End move between tabs
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key;
        var to = k === 'ArrowRight' ? (i + 1) % n : k === 'ArrowLeft' ? (i - 1 + n) % n : k === 'Home' ? 0 : k === 'End' ? n - 1 : -1;
        if (to < 0) return;
        e.preventDefault(); activate(to, true);
      });
    });
    section.querySelectorAll('.hb-pc__viewport').forEach(function (vp) {
      var scroller = vp.querySelector('.hb-pc__scroller');
      var prev = vp.querySelector('.hb-pc__arrow--prev');
      var next = vp.querySelector('.hb-pc__arrow--next');
      if (!scroller) return;
      function step() {
        var slide = scroller.querySelector('.hb-pc__slide:not(.hb-pc__slide--feature)') || scroller.querySelector('.hb-pc__slide');
        return slide ? slide.getBoundingClientRect().width + 4 : scroller.clientWidth * 0.8;
      }
      function update() {
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        // the last snap point can stop a few px short of the true end; treat anything within 12px as the end
        if (next) next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 12;
      }
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
    section.querySelectorAll('.hb-card__wish').forEach(bindWishlist);
    // swatch click swaps the card image when a variant image is provided
    section.querySelectorAll('.hb-swatch').forEach(function (sw) {
      sw.setAttribute('aria-pressed', String(sw.classList.contains('is-active')));
      sw.addEventListener('click', function () {
        var card = sw.closest('.hb-card');
        if (!card) return;
        var img = card.querySelector('.hb-card__img--main img');
        if (img && sw.dataset.image) { img.src = sw.dataset.image; img.removeAttribute('srcset'); }
        card.querySelectorAll('.hb-swatch').forEach(function (s) { var on = s === sw; s.classList.toggle('is-active', on); s.setAttribute('aria-pressed', String(on)); });
      });
    });
    section.querySelectorAll('form[data-hb-quick-add]').forEach(bindQuickAdd);
  }

  /* ---------- product page ---------- */
  // money_without_trailing_zeros in the shop's own format ("${{amount}}", "{{amount_with_comma_separator}} €", ...)
  // keepZeros prints "40.00" instead of "40", like Liquid's plain money filter
  function formatMoney(cents, format, keepZeros) {
    function fmt(n, places, thou, dec) {
      var parts = (n / 100).toFixed(places).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] && (keepZeros || Number(parts[1]) !== 0) ? whole + dec + parts[1] : whole;
    }
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      if (key === 'amount_with_apostrophe_separator') return fmt(cents, 2, "'", '.');
      return fmt(cents, 2, ',', '.');
    });
  }

  function initPdpGallery(gallery) {
    var track = gallery && gallery.querySelector('.hb-pdp__slides');
    if (!track) return null;
    var slides = track.querySelectorAll('.hb-pdp__slide');
    var bar = gallery.querySelector('[data-hb-gallery-bar]');
    var prev = gallery.querySelector('[data-hb-gallery-prev]');
    var next = gallery.querySelector('[data-hb-gallery-next]');
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    var thumbs = gallery.querySelectorAll('[data-hb-thumb]');
    thumbs.forEach(function (th) { th.addEventListener('click', function () { go(parseInt(th.dataset.hbThumb, 10)); }); });
    function update() {
      var i = index();
      if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
      thumbs.forEach(function (th, n) {
        var on = n === i;
        th.classList.toggle('is-active', on);
        if (on) {
          th.setAttribute('aria-current', 'true');
          // keep the active thumb in view by scrolling the strip only (never the page)
          var strip = th.parentElement, l = th.offsetLeft - strip.offsetLeft, r = l + th.offsetWidth;
          if (l < strip.scrollLeft) strip.scrollLeft = l - 16;
          else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = r - strip.clientWidth + 16;
        }
        else th.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      // only the visible slide's video plays
      slides.forEach(function (s, n) { var v = s.querySelector('video'); if (v) { if (n === i) v.play().catch(function () {}); else v.pause(); } });
    }
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return {
      goToMedia: function (id) {
        for (var i = 0; i < slides.length; i++) if (slides[i].dataset.mediaId === String(id)) { go(i); return; }
      }
    };
  }

  function initPdp(root) {
    var data = {};
    var dataEl = root.querySelector('[data-hb-pdp-json]');
    try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) {}
    var variants = data.variants || [];
    var gallery = initPdpGallery(root.querySelector('[data-hb-gallery]'));

    root.querySelectorAll('.hb-pdp__wish').forEach(bindWishlist);
    root.querySelectorAll('form[data-hb-quick-add]').forEach(bindQuickAdd);

    // model bio
    var bioBtn = root.querySelector('[data-hb-bio-toggle]');
    if (bioBtn) {
      var bio = document.getElementById(bioBtn.getAttribute('aria-controls'));
      bioBtn.addEventListener('click', function () {
        var open = bioBtn.getAttribute('aria-expanded') !== 'true';
        bioBtn.setAttribute('aria-expanded', String(open));
        if (bio) bio.hidden = !open;
      });
    }

    // drop-downs
    root.querySelectorAll('[data-hb-pdp-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    // pair with: arrows step one card
    var pair = root.querySelector('[data-hb-pair]');
    if (pair) {
      var pt = pair.querySelector('[data-hb-pair-track]');
      var pp = pair.querySelector('[data-hb-pair-prev]');
      var pn = pair.querySelector('[data-hb-pair-next]');
      var pstep = function () { var c = pt.querySelector('.hb-pair'); return c ? c.getBoundingClientRect().width + 8 : pt.clientWidth * 0.8; };
      var pupdate = function () {
        if (pp) pp.disabled = pt.scrollLeft <= 2;
        if (pn) pn.disabled = pt.scrollLeft + pt.clientWidth >= pt.scrollWidth - 12;
      };
      if (pp) pp.addEventListener('click', function () { pt.scrollBy({ left: -pstep(), behavior: 'smooth' }); });
      if (pn) pn.addEventListener('click', function () { pt.scrollBy({ left: pstep(), behavior: 'smooth' }); });
      pt.addEventListener('scroll', pupdate, { passive: true });
      window.addEventListener('resize', pupdate);
      pupdate();
    }

    // variant picker
    var form = root.querySelector('[data-hb-pdp-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-hb-variant-id]');
    var atc = form.querySelector('[data-hb-atc]');
    var errorEl = form.querySelector('[data-hb-atc-error]');
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-hb-option]'));
    var priceEl = root.querySelector('[data-hb-price]');
    var compareEl = root.querySelector('[data-hb-compare]');
    var instalEl = root.querySelector('[data-hb-instal]');
    var selected = groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    var current = null;
    var addedTimer;

    function optionIndex(g) { return Number(g.dataset.hbOption); }
    function matches(v, skip) {
      return groups.every(function (g) {
        var i = optionIndex(g);
        return i === skip || selected[groups.indexOf(g)] === null || v.options[i] === selected[groups.indexOf(g)];
      });
    }
    function setLabel(text) { if (atc) atc.textContent = text; }
    function refresh(fromUser) {
      // strike out values with no stock given the other choices
      groups.forEach(function (g, gi) {
        var i = optionIndex(g);
        g.querySelectorAll('input').forEach(function (input) {
          var ok = variants.some(function (v) { return v.available && v.options[i] === input.value && matches(v, i); });
          input.parentElement.classList.toggle('is-unavailable', !ok);
        });
        var shown = g.querySelector('[data-hb-option-value]');
        if (shown && selected[gi] !== null) shown.textContent = selected[gi];
      });
      var complete = selected.every(function (v) { return v !== null; });
      current = complete ? variants.filter(function (v) { return matches(v, -1); })[0] || null : null;
      if (current) {
        if (idInput.value !== String(current.id)) {
          idInput.value = current.id;
          // Shopify's payment terms message listens for this to update its price
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (priceEl) priceEl.textContent = formatMoney(current.price, data.moneyFormat);
        if (compareEl) { compareEl.hidden = !(current.compare > current.price); compareEl.textContent = formatMoney(current.compare, data.moneyFormat); }
        if (instalEl && data.instalments) instalEl.textContent = formatMoney(Math.floor(current.price / data.instalments), data.moneyFormat, true);
        if (atc) { atc.disabled = !current.available; setLabel(current.available ? atc.dataset.labelAdd : atc.dataset.labelSold); }
        if (fromUser) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
          if (current.media && gallery) gallery.goToMedia(current.media);
        }
      } else if (atc) {
        atc.disabled = complete; // a combination that doesn't exist at all
        setLabel(complete ? atc.dataset.labelSold : atc.dataset.labelSelect);
      }
    }
    groups.forEach(function (g, gi) {
      g.addEventListener('change', function (e) {
        if (!e.target.matches('input[type=radio]')) return;
        selected[gi] = e.target.value;
        g.classList.remove('is-missing');
        var m = g.querySelector('.hb-pdp__missing'); if (m) m.hidden = true;
        if (errorEl) errorEl.hidden = true;
        refresh(true);
      });
    });
    refresh(false);

    form.addEventListener('submit', function (e) {
      // without JS support the form posts normally
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var missing = groups.filter(function (g, gi) { return selected[gi] === null; });
      if (missing.length) {
        missing.forEach(function (g) { g.classList.add('is-missing'); var m = g.querySelector('.hb-pdp__missing'); if (m) m.hidden = false; });
        var first = missing[0].querySelector('input');
        if (first) first.focus();
        return;
      }
      if (!current || !current.available) return;
      atc.setAttribute('aria-busy', 'true');
      if (errorEl) errorEl.hidden = true;
      var body = new FormData(form);
      body.set('id', current.id);
      addToCart(body)
        .then(function () {
          setLabel(atc.dataset.labelAdded);
          clearTimeout(addedTimer);
          addedTimer = setTimeout(function () { refresh(false); }, 2500);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message || 'Could not add to bag'; errorEl.hidden = false; }
        })
        .then(function () { atc.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- product picks from Shopify recommendations: fetched after load ---------- */
  function initRecs(shell) {
    var url = shell.dataset.hbRecsUrl;
    if (!url || !window.fetch) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.hb-recs');
        if (!fresh) { shell.remove(); return; }
        shell.replaceWith(fresh);
        boot(fresh.parentElement);
      })
      .catch(function () { shell.remove(); });
  }

  /* ---------- instagram strip: arrows + keep the focused tile in view ---------- */
  function initInsta(section) {
    var track = section.querySelector('.hb-insta__track');
    var prev = section.querySelector('.hb-pc__arrow--prev');
    var next = section.querySelector('.hb-pc__arrow--next');
    if (!track) return;
    function step() { var tile = track.querySelector('.hb-insta__tile'); return tile ? tile.getBoundingClientRect().width + 4 : track.clientWidth * 0.8; }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 12;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track.addEventListener('focusin', function (e) {
      var tile = e.target.closest('.hb-insta__tile');
      if (tile) tile.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    update();
  }

  /* ---------- collection page: sort, grid size, read more ---------- */
  function initCollection(root) {
    var sort = root.querySelector('[data-hb-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    var grid = root.querySelector('[data-hb-grid]');
    var btns = root.querySelectorAll('[data-hb-view]');
    function setView(v) {
      if (!grid) return;
      grid.dataset.view = v;
      btns.forEach(function (b) { var on = b.dataset.hbView === v; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
      try { localStorage.setItem('hb-coll-view', v); } catch (e) {}
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { setView(b.dataset.hbView); }); });
    try { var saved = localStorage.getItem('hb-coll-view'); if (saved) setView(saved); } catch (e) {}
    var more = root.querySelector('[data-hb-more]');
    var moreBtn = root.querySelector('[data-hb-more-toggle]');
    if (more && moreBtn) {
      // hide the toggle when the text already fits in two lines
      if (more.scrollHeight <= more.clientHeight + 2) moreBtn.hidden = true;
      moreBtn.addEventListener('click', function () {
        var open = more.classList.toggle('is-open');
        moreBtn.setAttribute('aria-expanded', String(open));
        moreBtn.textContent = open ? 'Read less' : 'Read more';
      });
    }
  }

  /* ---------- footer accordion ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.hb-acc__title').forEach(function (btn) {
      if (!claim(btn, 'Acc')) return;
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(root) {
    root = root || document;
    // Shopify's video_tag adds a fallback still with no alt; it duplicates the video, so mark it decorative
    root.querySelectorAll('.hb video img:not([alt])').forEach(function (img) { img.setAttribute('alt', ''); });
    initAnimations(root);
    root.querySelectorAll('.hb-topbar:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initTopbar(el); });
    root.querySelectorAll('.hb-header:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initHeader(el); });
    root.querySelectorAll('.hb-hero:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initHero(el); });
    root.querySelectorAll('.hb-pc:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initProductCarousel(el); });
    root.querySelectorAll('.hb-pdp:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initPdp(el); });
    root.querySelectorAll('.hb-recs-shell:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initRecs(el); });
    root.querySelectorAll('.hb-insta:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initInsta(el); });
    root.querySelectorAll('[data-hb-wishlist]:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initWishlistPage(el); });
    root.querySelectorAll('[data-hb-coll]:not([data-hb-ready])').forEach(function (el) { el.dataset.hbReady = '1'; initCollection(el); initProductCarousel(el); });
    initAccordions(root);
    initModals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
